import { combineReducers } from "redux";
import { profiles } from "./redux/reducers/profiles";
import { profileCard } from "./redux/reducers/profileCard";

export const Employees = combineReducers({
    profiles,
    profileCard,
});
